import type { RegisterMobilePushEndpointPersonRequest } from '@DigitaleDoerfer/digitale-doerfer-api';

import { useSharedPushApi } from '@/features/api/hooks/shared-push/useSharedPushApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useRegisterMobilePushEndpoint = () => {
  const api = useSharedPushApi();

  return useApiMutation({
    mutationFn: (request: RegisterMobilePushEndpointPersonRequest) =>
      api.registerMobilePushEndpointPerson(request)
  });
};
